function stripHtml(value) {
    if (!value) return "";

    return String(value)
        .replace(/<\/p>\s*<p[^>]*>/gi, "\n\n")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/?[^>]+>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&quot;/gi, "\"")
        .replace(/&#39;/g, "'")
        .replace(/&auml;/gi, "ä")
        .replace(/&ouml;/gi, "ö")
        .replace(/&uuml;/gi, "ü")
        .replace(/&Auml;/g, "Ä")
        .replace(/&Ouml;/g, "Ö")
        .replace(/&Uuml;/g, "Ü")
        .replace(/&szlig;/gi, "ß");
}

function escapeHtml(value) {
    return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

function normalizeWhitespace(value) {
    return String(value || "")
        .replace(/\r\n/g, "\n")
        .replace(/[ \t]+/g, " ")
        .replace(/\n[ \t]+/g, "\n")
        .replace(/[ \t]+\n/g, "\n")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
}

function truncateAtSentence(value, maxLength) {
    if (value.length <= maxLength) return value;

    const clipped = value.slice(0, maxLength);
    const sentenceEnd = Math.max(
        clipped.lastIndexOf("."),
        clipped.lastIndexOf("!"),
        clipped.lastIndexOf("?")
    );

    if (sentenceEnd > maxLength * 0.55) {
        return clipped.slice(0, sentenceEnd + 1).trim();
    }

    const wordEnd = clipped.search(/\s+\S*$/);
    if (wordEnd > maxLength * 0.55) {
        return clipped.slice(0, wordEnd).trim();
    }

    return clipped.trim();
}

function withParagraphBreaks(value) {
    return String(value || "")
        .replace(/([.!?…]["']?)([A-ZÄÖÜ])/g, "$1\n\n$2");
}

export function splitParagraphs(value) {
    const text = contentText(withParagraphBreaks(value));
    if (!text) return [];

    return text
        .split(/\n\s*\n+/)
        .map((paragraph) => paragraph.trim())
        .filter(Boolean);
}

export function contentText(value) {
    return normalizeWhitespace(stripHtml(value));
}

export const TYPESENSE_SUMMARY_LIMIT = 600;

export function formatContentHtml(value) {
    const paragraphs = splitParagraphs(value);
    if (!paragraphs.length) return "";

    return paragraphs.map(escapeHtml).join("<br /><br />");
}

export function isLikelyIndexTruncated(value, limit = TYPESENSE_SUMMARY_LIMIT) {
    const text = contentText(value);
    if (!text) return false;

    if (text.length >= limit - 3) {
        return true;
    }

    return text.length >= limit * 0.85 && !/[.!?…]$/.test(text);
}

export function buildContentShort(value, maxLength = 320) {
    const paragraphs = splitParagraphs(value);
    const firstParagraph = paragraphs[0] || "";
    if (!firstParagraph) return "";

    const teaser = truncateAtSentence(firstParagraph, maxLength);
    return escapeHtml(teaser);
}
